<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { GridHelper } from 'three'
import { PlaneBufferGeometry, MeshBasicMaterial, Mesh, Color } from 'three'

export default {
  mixins: [O3DG2],
  methods: {
    setup () {
      const size = 3000
      const divisions = 3000 / 10

      const grid = new GridHelper(size, divisions)
      this.o3d.add(grid)

      const planeGeo = new PlaneBufferGeometry(size, size, 2, 2)
      planeGeo.rotateX(Math.PI * -0.5)
      const planeMat = new MeshBasicMaterial({ color: new Color('#eeeeee') })
      const planeMesh = new Mesh(planeGeo, planeMat)
      planeMesh.visible = false
      // if (this.ctx.matcap) {
      //   planeMesh.material = this.ctx.matcap.silver
      // }

      this.o3d.add(planeMesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>
</style>
